import React from 'react';

const APP_STORE_URL =
  'https://apps.apple.com/us/app/pictureit-draw-charades/id1514525835';
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.devroldy.picture_it';

function Platforms() {
  return (
    <section className="platforms" id="platforms">
      <div className="wrap">
        <div className="section-head">
          <div className="section-pill">
            <span className="section-pill-dot"></span> Download
          </div>
          <h2 className="section-h2">Play on any device</h2>
          <p className="section-p">
            Available on the App Store and Google Play. Start drawing wherever
            you are.
          </p>
        </div>

        <div className="plat-row">
          {/* iOS Card */}
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="plat-card reveal"
          >
            <div className="plat-card-icon plat-card-icon-apple">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="#1d1d1f">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
            </div>
            <span className="plat-card-name">iOS</span>
            <span className="plat-card-sub">iPhone · iPad · Mac · Vision</span>
          </a>

          {/* Android Card */}
          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="plat-card reveal reveal-d1"
          >
            <div className="plat-card-icon plat-card-icon-android">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="#3ddc84">
                <path d="M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V7H6v11zM3.5 7C2.67 7 2 7.67 2 8.5v7c0 .83.67 1.5 1.5 1.5S5 16.33 5 15.5v-7C5 7.67 4.33 7 3.5 7zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85.55 12.95.23 12 .23c-.94 0-1.84.32-2.64.91L7.88.66c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.79 6 5.55 6 7h12c0-1.45-.97-3.21-2.47-4.34zM10 5H9V4h1v1zm5 0h-1V4h1v1z" />
              </svg>
            </div>
            <span className="plat-card-name">Android</span>
            <span className="plat-card-sub">Phones · Tablets</span>
          </a>
        </div>

        {/* Store download buttons */}
        <div className="store-row">
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="store-link reveal"
          >
            <span className="store-link-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
            </span>
            <span className="store-link-text">
              <span className="store-link-label">Download on the</span>
              <span className="store-link-name">App Store</span>
            </span>
          </a>

          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="store-link reveal reveal-d1"
          >
            <span className="store-link-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
              </svg>
            </span>
            <span className="store-link-text">
              <span className="store-link-label">Get it on</span>
              <span className="store-link-name">Google Play</span>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Platforms;